module.exports = __webpack_public_path__ + "img/u2741.62279121.svg";